/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author        Afternet <info@afternet.gr>
 * @copyright   Afternet
 * @license        http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import {createTabsListingSpin, placeListErrors} from "./front/_front";
import {getProductList, getUnitsData} from "./front/_productListFuctions";
import tabsSlider from "./sliders/tabsSlider";

export default function step3Standard(){

    let xhr_getJobTypeProductList = null;

    $(document).on('change', '.js-manufacturer-selection', function (e){
        e.stopPropagation();

        let data = getUnitsData();
        if(!data){ return; }

        getJobTypeProductList(data);

    });

    function getJobTypeProductList(data){

        xhr_getJobTypeProductList = $.ajax({
            method: "POST",
            url: afpw_ajax_url,
            beforeSend: function () {
                if(xhr_getJobTypeProductList != null){ xhr_getJobTypeProductList.abort(); }
                if($('.js-jobProductList').length){
                    $('.js-jobProductList').remove();
                }
                if($('.js-kx-flow .alert').length){
                    $('.js-kx-flow .alert').remove();
                }
                $('.js-kx-flow').append('<div class="kx-loader"></div>');
            },
            cache: false,
            data: {
                ajax: true,
                action: 'getJobTypeProductList',
                hash: afpw_hash,
                data: $.param(data)
            },
        }).done(function (data, textStatus, jqXHR){
            try {
                var obj = jQuery.parseJSON(data);
                if (obj.status == 'success') {
                    if($('.js-jobProductList').length){
                        $('.js-jobProductList').remove();
                    }
                    $('.js-kx-flow').append(obj.html);
                    createTabsListingSpin();
                    getProductList();
                    console.log('sdfsf');
                    tabsSlider();

                    if($('.js-jobProductList').length){
                        var _top = $('.js-jobProductList').offset().top;
                        window.scrollTo({
                            top: _top - 110,
                            behavior: "smooth"
                        });
                    }

                } else {
                    if (typeof(obj.errors) != 'undefined' ) {
                        $.each(obj.errors, function(key,value) {
                            placeListErrors(value);
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            placeListErrors('Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα');
            console.log(errorThrown);
        }).always(function() {
            xhr_getJobTypeProductList = null;
            $('.kx-loader').remove();
        });
    }

}



